import React from "react";
import FilterHeader from "../../components/FilterHeader";
import FilterDate from "../../components/FilterDate";

const Date = () => {
  return (
    <>
      <FilterHeader />
      <FilterDate />
    </>
  );
};

export default Date;
